/** @format */

import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectorViewMap } from '../selectors';
import { TListType } from '../../filters/declarations';
import { checkDefaultFiltersPoi } from '../../../utils/helpers/checkDefaultFiltersPoi';

export const useGTMListType = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(store => store.general);
  const isViewMap = useAppSelector(selectorViewMap);
  const { isDefaultFilters } = checkDefaultFiltersPoi('allFilters');

  const onChangeGTMListType = (payload: TListType) => {
    const lastElement = state.GTMListType ? state.GTMListType.length - 1 : 0;
    if (!state.GTMListType) return null;

    if (
      state.GTMListType[lastElement] === payload &&
      payload !== 'sorting_by_product_filters' &&
      payload !== 'search_result' &&
      payload !== 'related_products'
    )
      dispatch({
        type: 'REMOVE_GTM_LIST_TYPE',
        payload,
      });
    else if (state.GTMListType[lastElement] === payload && payload === 'sorting_by_product_filters' && isDefaultFilters)
      dispatch({
        type: 'REMOVE_GTM_LIST_TYPE',
        payload,
      });
    else if (state.GTMListType[lastElement] !== payload) {
      switch (payload) {
        case 'view_on_map':
          if (isViewMap) {
            return dispatch({
              type: 'SET_GTM_LIST_TYPE',
              payload,
            });
          } else {
            return dispatch({
              type: 'REMOVE_GTM_LIST_TYPE',
              payload,
            });
          }
        case 'sorting_by_product_filters':
          if (!isDefaultFilters) {
            return dispatch({
              type: 'SET_GTM_LIST_TYPE',
              payload,
            });
          } else {
            return null;
          }
        case 'search_result':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
        case 'related_products':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
        case 'homepage':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
        case 'promo_click':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
        case 'city_page':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
        case 'neighborhoods_page':
          return dispatch({
            type: 'SET_GTM_LIST_TYPE',
            payload,
          });
      }
    }
  };

  return { onChangeGTMListType };
};
